<template>
  <div class="fragment">
    <div class="order-create__section-label section-label"
         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['fbm_SendFromInformation'])"></div>
      {{ $t('fbm_SendFromInformation.localization_value.value') }}
    </div>

    <div class="order-create__row custom-row" v-if="!isAdminEdit">
      <div class="order-create__col custom-col custom-col--66 custom-col--md-66 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <DefaultSelect
            :options="options"
            :label="''"
            :otherValue="'sendFrom'"
            v-bind:class="{'ui-no-valid': FBM.validation.sendFrom}"
            :errorTxt="$t(`${FBM.validationTranslate.sendFrom}.localization_value.value`)"
            :error="FBM.validation.sendFrom"
            :selected="FBM.data.sendFrom"
            :clearable="false"
            @change="val => {FBM.data.sendFrom = val}"
        />
      </div>
      <div class="order-create__col custom-col custom-col--33 custom-col--md-33 custom-col--sm-100"
           v-if="!(isAdmin && isAdminEdit)"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <MainButton class="btn-fit-content btn-right-block-i"
                    :value="$t('common_AddNew.localization_value.value')"
                    :ico="'ico'"
                    @click.native="isSendFromDataPopup = true"
        >
          <template slot="ico">
            <PlusIconSVG class="btn-icon-plus"/>
          </template>
        </MainButton>
      </div>
    </div>

    <div class="order-create__row custom-row" v-else-if="FBM.data.sendFrom && isAdminEdit">
      <div class="order-create__col custom-col custom-col--33 custom-col--md-50 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <DefaultInput
            :label="$t('common_name.localization_value.value')"
            :type="'text'"
            :name="'firstName'"
            v-bind:class="{'ui-no-valid': FBM.validationTranslate.sendFrom}"
            :errorTxt="$t(`${FBM.validationTranslate.sendFrom}.localization_value.value`)"
            :error="FBM.validation.sendFrom"
            v-model="FBM.data.sendFrom.first_name"
        />
      </div>
      <div class="order-create__col custom-col custom-col--33 custom-col--md-50 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <DefaultInput
            :label="$t('common_surName.localization_value.value')"
            :type="'text'"
            :name="'firstName'"
            v-bind:class="{'ui-no-valid': FBM.validationTranslate.sendFrom}"
            :errorTxt="$t(`${FBM.validationTranslate.sendFrom}.localization_value.value`)"
            :error="FBM.validation.sendFrom"
            v-model="FBM.data.sendFrom.last_name"
        />
      </div>
      <div class="order-create__col custom-col custom-col--33 custom-col--md-50 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <DefaultInput
            :label="$t('profile_companyName.localization_value.value')"
            :type="'text'"
            :name="'firstName'"
            v-bind:class="{'ui-no-valid': FBM.validationTranslate.sendFrom}"
            :errorTxt="$t(`${FBM.validationTranslate.sendFrom}.localization_value.value`)"
            :error="FBM.validation.sendFrom"
            v-model="FBM.data.sendFrom.company_name"
        />
      </div>
    </div>


    <SendFromDataPopup
        v-if="isSendFromDataPopup && !(isAdmin && isAdminEdit)"
        :type="'create'"
        @successAdd="getSenderData"
        @close="isSendFromDataPopup = false"
    />

  </div>
</template>

<script>
import DefaultSelect from "@/components/UI/selectiones/DefaultSelect/DefaultSelect";
import MainButton from "@/components/UI/buttons/MainButton/MainButton";
import PlusIconSVG from '../../../../../../../../public/img/UI-group/plus-icon.svg?inline'
import SendFromDataPopup from "@/components/coreComponents/Popups/SendFromDataPopup/SendFromDataPopup";
import DefaultInput from "@/components/UI/inputs/DefaultInput/DefaultInput";

export default {
  name: "SendFromBlock",

  components: {DefaultInput, SendFromDataPopup, MainButton, DefaultSelect, PlusIconSVG},

  props: {
    FBM: Object,
    isAdminEdit: Boolean,
    isEdit: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getUser() {
      return this.FBM.data.User.user
    }
  },

  watch: {
    getUser() {
      if(this.isEdit) {
        this.options = this.FBM.data.Order.data.orderOBJ?.send_from_list?.data
        return
      }

      if(this.isAdmin && this.FBM.data.User.user?.id) {
        this.$store.dispatch('fetchOrderSendFrom', '?filter[userId]='+this.FBM.data.User.user?.id).then(response => {
          this.options = this.getRespPaginateData(response)
        })
      }
    }
  },

  data() {
    return {
      options: [],
      isSendFromDataPopup: false,
    }
  },

  mounted() {
    this.getSenderData()
  },

  methods: {
    getSenderData() {
      // console.log(213123);
      // console.log(this.isEdit);
      // if(this.isEdit) {
      //   console.log(this.FBM.data.Order.data.orderOBJ?.send_from_list);
      //   this.options = this.FBM.data.Order.data.orderOBJ?.send_from_list?.data
      //   return
      // }

      if(this.isAdminEdit) return

      if(this.FBM.data.Order.data.orderOBJ?.send_from_list?.data) {
        this.options = this.FBM.data.Order.data.orderOBJ?.send_from_list?.data
        return
      }

      this.$store.dispatch('fetchOrderSendFrom').then(response => {
        this.options = this.getRespPaginateData(response)
        if(!this.FBM.data.sendFrom && this.options.length > 0) {
          this.FBM.data.sendFrom = this.options[0]
        }
      })
    },
  },

}
</script>

<style scoped>

</style>